@if (data.title) {
  <h1 mat-dialog-title>{{data.title | translate}}</h1>
}
<div mat-dialog-content>
  <p [innerHTML]="data.message | translate : data.messageParams"></p>
</div>
@if (data.actions.length > 0) {
  <div mat-dialog-actions>
    @for (action of data.actions; track action) {
      <button mat-button [color]="action.color" (click)="onActionClick(action)">
        {{action.title | translate}}
      </button>
    }
  </div>
}
